import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { useDispatch, useSelector } from "react-redux";
import { fetchMasterData } from '../../../../redux/actions/masterdataActions';

const Kundli_Common_Section = () => {
    const dispatch = useDispatch();
    const [is_loading, set_Is_Loading] = useState(false)
    const { horoscopePages, loading, error } = useSelector(
        (state) => state?.masterdata
    );

    useEffect(() => {
        dispatch(fetchMasterData());
    }, [dispatch]);

    const Horoscope = horoscopePages?.find((item) => item?.page_name === "horoscope")
    const KundaliMatching = horoscopePages?.find((item) => item?.page_name === "kundli-matching")
    const FreeKundali = horoscopePages?.find((item) => item?.page_name === "free-kundli")
    const TodayPanchang = horoscopePages?.find((item) => item?.page_name === "panchang")
    const LoveCalculator = horoscopePages?.find((item) => item?.page_name === "love-calculator")
    
    return (
        <div>
            <section
                className="gi-service-section text-[#000] bg-gradient-to-r from-[#cdc5c5] to-[#f1f0ed] py-[40px] max-[767px]:py-[30px]">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-[-12px] mb-[-12px]">

                        <div className="w-full wow fadeInUp" data-wow-delay=".4s">
                            <div
                                className="gi-ser-inner transition-all duration-[0.3s] ease delay-[0s] text-center">
                                <Link to={`/page/${FreeKundali?.slug}`}>
                                    <div className="gi-service-image mb-3">
                                        <img src={Common_Images_Transport?.free_kundli2} className="m-auto w-20 md:w-32 rounded-full border border-white border-2" alt="" />
                                    </div>
                                    <div className="gi-service-desc">
                                        <h3 className="font-Poppins text-[14px] uppercase font-medium">
                                            Free Kundali</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="w-full wow fadeInUp" data-wow-delay=".4s">
                            <div
                                className="gi-ser-inner transition-all duration-[0.3s] ease delay-[0s] text-center">
                                <Link to={`/page/${KundaliMatching?.slug}`}>
                                    <div className="gi-service-image mb-3">
                                        <img src={Common_Images_Transport?.ku_ma} className="m-auto w-20 md:w-32 rounded-full border border-white border-2" alt="" />
                                    </div>
                                    <div className="gi-service-desc">
                                        <h3 className="font-Poppins text-[14px] uppercase font-medium">
                                            Kundli Matching</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="w-full wow fadeInUp" data-wow-delay=".4s">
                            <div
                                className="gi-ser-inner transition-all duration-[0.3s] ease delay-[0s] text-center">
                                <Link to={`/page/${TodayPanchang?.slug}`}>
                                    <div className="gi-service-image mb-3">
                                        <img src={Common_Images_Transport?.panchange} className="m-auto w-20 md:w-32 rounded-full border border-white border-2" alt="" />
                                    </div>
                                    <div className="gi-service-desc">
                                        <h3 className="font-Poppins text-[14px] uppercase font-medium">
                                            Panchange</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="w-full wow fadeInUp" data-wow-delay=".4s">
                            <div
                                className="gi-ser-inner transition-all duration-[0.3s] ease delay-[0s] text-center">
                                <Link to={`/horoscope/${Horoscope?.slug}`}>
                                    <div className="gi-service-image mb-3">
                                        <img src={Common_Images_Transport?.daily_horoscope} className="m-auto w-20 md:w-32 rounded-full border border-white border-2" alt="" />
                                    </div>
                                    <div className="gi-service-desc">
                                        <h3 className="font-Poppins text-[14px] uppercase font-medium">
                                            Daily Horoscope</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="w-full wow fadeInUp" data-wow-delay=".4s">
                            <div
                                className="gi-ser-inner transition-all duration-[0.3s] ease delay-[0s] text-center">
                                <Link to={`/page/${LoveCalculator?.slug}`}>
                                    <div className="gi-service-image mb-3">
                                        <img src={Common_Images_Transport?.love_calculater} className="m-auto w-20 md:w-32 rounded-full border border-white border-2" alt="" />
                                    </div>
                                    <div className="gi-service-desc">
                                        <h3 className="font-Poppins text-[14px] uppercase font-medium">
                                            Love Calculater</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default Kundli_Common_Section